import React from "react";
import ReactDOM from "react-dom/client";
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from "./App";
import config from "./config";

// Inject GA script dynamically so missing/invalid IDs do not ship broken placeholders.
function initGoogleAnalytics(gaId) {
    if (!gaId) {
        if (process.env.NODE_ENV === 'production') {
            console.warn('Google Analytics is disabled: REACT_APP_GA_ID is not set.');
        }
        return;
    }

    if (document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${gaId}"]`)) {
        return;
    }

    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(gaScript);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }

    window.gtag = window.gtag || gtag;
    window.gtag('js', new Date());
    window.gtag('config', gaId);
}

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '50px',
                    textAlign: 'center',
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f8f9fa'
                }}>
                    <h1 style={{ color: '#dc3545', marginBottom: '20px' }}>Oops! Something went wrong.</h1>
                    <p style={{ fontSize: '1.2rem', color: '#6c757d', maxWidth: '600px', margin: '0 auto 10px' }}>
                        We're sorry for the inconvenience. A technical error has occurred.
                    </p>
                    {this.state.error && (
                        <p style={{ fontSize: '0.9rem', color: '#dc3545', maxWidth: '600px', margin: '0 auto 30px', fontFamily: 'monospace' }}>
                            Error: {this.state.error.message}
                        </p>
                    )}
                    {!this.state.error && (
                         <p style={{ fontSize: '1.2rem', color: '#6c757d', maxWidth: '600px', margin: '0 auto 30px' }}>
                            Please try refreshing the page or contact support if the issue persists.
                        </p>
                    )}
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '12px 24px',
                            fontSize: '1rem',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

const root = ReactDOM.createRoot(document.getElementById("root"));

initGoogleAnalytics(config.gaId);

root.render(
    // Optionally disable StrictMode in production
    process.env.NODE_ENV === 'production' ? (
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    ) : (
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    )
);
